import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState = {
  isLoadingCallBack: false,
  isSuccessCallBack: false,
  isLoadingTariffRequest: false,
  isSuccessTariffRequest: false,
}

const contactsSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    setIsLoadingCallBack(state, { payload }: PayloadAction<boolean>) {
      state.isLoadingCallBack = payload
    },
    setIsSuccessCallBack(state, { payload }: PayloadAction<boolean>) {
      state.isSuccessCallBack = payload
    },
    setIsLoadingTariffRequest(state, { payload }: PayloadAction<boolean>) {
      state.isLoadingTariffRequest = payload
    },
    setIsSuccessTariffRequest(state, { payload }: PayloadAction<boolean>) {
      state.isSuccessTariffRequest = payload
    },
  },
})

export type ContactsStateType = typeof initialState

export const {
  setIsLoadingCallBack,
  setIsSuccessCallBack,
  setIsLoadingTariffRequest,
  setIsSuccessTariffRequest,
} = contactsSlice.actions
export const contactsReducer = contactsSlice.reducer
